import React from 'react';
import styles from '../assets/BrandedNav.module.css';
import { BreakpointEnum, useBreakpoint } from '../service/breakpointService';

const { ThemeProvider, dlsBrightBlueBg, dlsWhite } = require('@americanexpress/dls-react');

interface BrandedNavProps {
  children: React.ReactNode
}

const BrandedNav: React.FC<BrandedNavProps> = (props) => {
  const breakpoint = useBreakpoint(); 
  return (
    <ThemeProvider designTokens={{}} theme={{ ...dlsBrightBlueBg, ...dlsWhite }}>
      <header className={`nav dls-bright-blue-bg ${breakpoint === BreakpointEnum.XSmall ? styles['header-height-xsmall'] + ' pad-2-t pad-2-l' : 'col-12 flex flex-justify-between flex-align-center'} ${styles.header}`}>
        {props.children}
      </header>
    </ThemeProvider>
  );
};

export default BrandedNav;
